import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Analytics from '../utils/analytics';

/**
 * Component that tracks page views for Meta Pixel and Google Analytics
 * Should be placed inside the Router component
 */
const PageViewTracker = () => {
  const location = useLocation();

  // Analytics initialization is handled in index.html

  // Track page view on route change
  useEffect(() => {
    // Small delay to ensure page is fully loaded
    const timer = setTimeout(() => {
      Analytics.trackPageView(location.pathname, document.title);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageViewTracker;

